// extracted by mini-css-extract-plugin
module.exports = {"tabsList":"styles_tabsList__1kOMi","tabButton":"styles_tabButton__30CCO","selectedTab":"styles_selectedTab__2iibA","scrollButton":"styles_scrollButton__34mpp"};